import { TServicePackageEvents } from '../types/events';

/**
 * Формирует и отправляет нативные события в объект Window.
 * Может передавать какие-то данные, которые будут доступны в поле `detail`.
 */
export const sendEvent: TServicePackageEvents = (eventName, data?) => {
  if (typeof window !== 'undefined') {
    let event;

    if (data) {
      event = new CustomEvent(eventName, { detail: data });
    } else {
      event = new Event(eventName);
    }

    window.dispatchEvent(event);
  }
};
